module.exports = __webpack_public_path__ + "static/media/few clouds 02d.2c5926b1.png";